import {GET_DEPARTAMENTOS, GET_OPERADORES, GET_FILAS, GET_PAUSAS} from './mutations-types';
import monitorOperadorHttpService from "../_service/monitorOperadorHttpService";

export default {
  listarDepartamentos: async ({ commit }) => {
    try {
      const response = await monitorOperadorHttpService.getDepartamento();
      commit(GET_DEPARTAMENTOS, response.data);
    } catch (error) {
      console.log(error);
    }
  },
  listarOperadores: async ({ commit }) => {
    try {
      const response = await monitorOperadorHttpService.getOperador();
      commit(GET_OPERADORES, response.data);
    } catch (error) {
      console.log(error);
    }
  },
  listarFilas: async ({ commit }) => {
    try {
      const response = await monitorOperadorHttpService.getFilas();
      commit(GET_FILAS, response.data);
    } catch (error) {
      console.log(error);
    }
  },
  listarPausas: async ({ commit }) => {
    try {
      const response = await monitorOperadorHttpService.getPausas()
      commit(GET_PAUSAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}